// Balcão: o campo de busca fica SEMPRE com o cursor (pedido do dono, 29/09/2026:
// "ele deve ficar com esse input em aberto"). Clicou num produto, numa
// categoria ou num botão do carrinho, o cursor volta para a busca — pronta para
// a próxima leitura do código de barras. Não rouba o cursor de outro campo de
// texto nem de popup aberto (montagem do produto, pizza, avisos).
import { useEffect } from "react";

const CAMPOS_DE_TEXTO = ["INPUT", "TEXTAREA", "SELECT"];

export function useFocoNaBusca(buscaRef, ativo = true) {
  useEffect(() => {
    if (!ativo) return undefined;
    let timer;
    const devolverFoco = () => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        const busca = buscaRef.current;
        const el = document.activeElement;
        if (!busca || el === busca) return;
        if (el && (CAMPOS_DE_TEXTO.includes(el.tagName) || el.isContentEditable)) return;
        // Popup aberto (ou ainda saindo, na animação de fechar): tenta de novo
        // em seguida — o foco volta para o card quando ele termina de fechar.
        if (document.querySelector('[role="dialog"], [role="alertdialog"]')) { timer = setTimeout(devolverFoco, 250); return; }
        busca.focus({ preventScroll: true });
      }, 0);
    };
    devolverFoco();
    document.addEventListener("focusin", devolverFoco);
    document.addEventListener("focusout", devolverFoco);
    document.addEventListener("pointerup", devolverFoco);
    return () => {
      clearTimeout(timer);
      document.removeEventListener("focusin", devolverFoco);
      document.removeEventListener("focusout", devolverFoco);
      document.removeEventListener("pointerup", devolverFoco);
    };
  }, [buscaRef, ativo]);
}
